import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listHubs: build.query<ListHubsApiResponse, ListHubsApiArg>({
      query: () => ({ url: `/api/v1/hubs` }),
    }),
    createHub: build.mutation<CreateHubApiResponse, CreateHubApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/hubs`,
        method: "POST",
        body: queryArg.createHub,
      }),
    }),
    getHubById: build.query<GetHubByIdApiResponse, GetHubByIdApiArg>({
      query: (queryArg) => ({ url: `/api/v1/hubs/${queryArg.id}` }),
    }),
    updateHub: build.mutation<UpdateHubApiResponse, UpdateHubApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/hubs/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.updateHub,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as hubsApi };
export type ListHubsApiResponse = /** status 200 OK */ Hub[];
export type ListHubsApiArg = void;
export type CreateHubApiResponse = /** status 200 OK */ Hub;
export type CreateHubApiArg = {
  createHub: CreateHub;
};
export type GetHubByIdApiResponse = /** status 200 OK */ Hub;
export type GetHubByIdApiArg = {
  id: string;
};
export type UpdateHubApiResponse = /** status 200 OK */ Hub;
export type UpdateHubApiArg = {
  id: string;
  updateHub: UpdateHub;
};
export type Coordinate = {
  latitude: number;
  longitude: number;
};
export type Hub = {
  id: string;
  name: string;
  position: Coordinate;
  active: boolean;
  address?: string;
  createdAt: string;
  updatedAt: string;
  radius?: number;
};
export type ErrorResponse = {
  /** Human-readable error message. */
  message: string;
  /** HTTP status code. */
  code: number;
};
export type CreateHub = {
  name: string;
  position: Coordinate;
  active: boolean;
  address?: string;
  radius?: number;
};
export type UpdateHub = {
  name: string;
  position: Coordinate;
  active: boolean;
  address: string;
  radius?: number;
};
